import React from "react";
import { FilterChipProps } from "./FilterChip.types";
import { ChipContainer, ChipIcon, IconWrapper } from "./FilterChip.styles";
import {
  Body6RegularTypography,
  Body6MediumTypography,
} from "../../primitives/Typography/typographyVariants";

export const FilterChip: React.FC<FilterChipProps> = ({
  label,
  isSelected = false,
  isDisabled = false,
  selectedCount,
  leftIcon,
  rightIcon,
  onClick,
  onLeftIconClick,
  onRightIconClick,
  dataCy,
}) => {
  const handleChipClick = () => {
    if (!isDisabled && onClick) {
      onClick(); // Call external onClick function if provided
    }
  };
  const handleLeftIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled && onLeftIconClick) onLeftIconClick();
  };

  const handleRightIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isDisabled && onRightIconClick) onRightIconClick();
  };

  const displayLabel =
    isSelected && selectedCount && selectedCount > 0
      ? `${label} (${selectedCount})`
      : label;

  return (
    <ChipContainer
      data-cy={dataCy}
      isSelected={isSelected}
      disabled={isDisabled}
      onClick={handleChipClick}
    >
      {leftIcon && (
        <IconWrapper
          isDisabled={isDisabled}
          isSelected={isSelected}
          onClick={onLeftIconClick ? handleLeftIconClick : undefined}
        >
          <ChipIcon className={leftIcon} />
        </IconWrapper>
      )}
      {isSelected ? (
        <Body6MediumTypography>{displayLabel}</Body6MediumTypography>
      ) : (
        <Body6RegularTypography>{displayLabel}</Body6RegularTypography>
      )}
      {rightIcon && (
        <IconWrapper
          isDisabled={isDisabled}
          isSelected={isSelected}
          onClick={onRightIconClick ? handleRightIconClick : undefined}
        >
          <ChipIcon className={rightIcon} />
        </IconWrapper>
      )}
    </ChipContainer>
  );
};

export default FilterChip;
